import { createAction, props } from '@ngrx/store';
import { Feedback } from '../../models/Feedback';

export const loadFeedback = createAction('[Feedback] Load Feedback');

export const loadFeedbackSuccess = createAction(
  '[Feedback] Load Feedback Success',
  props<{ feedback: Feedback[] }>()
);

export const submitFeedback = createAction(
  '[Feedback] Submit Feedback',
  props<{ feedbackText: string; rating: number; userName: string }>()
);

export const submitFeedbackSuccess = createAction(
  '[Feedback] Submit Feedback Success',
  props<{ feedback: Feedback }>()
);

export const submitFeedbackFailure = createAction(
  '[Feedback] Submit Feedback Failure',
  props<{ error: any }>()
);
